import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router'
import styles from '../styles/PageBtns.module.scss'
import Arrow from '../../../assets/img/arrow.svg'
import { DepartmentService } from '../../../services/DepartmentService'
import { useAppDispatch } from '../../../app/hooks'
import {
  setCompanyList,
  setDepartmentList,
  setLicenseList,
} from '../../../slice/companySlice'
import { routeNames } from '../../../constants/routeNames'
import { CompanyService } from '../../../services/CompanyService'
import { LicenseService } from '../../../services/LicenseService'

type pageStateType = {
  current_page: number | null
  from: number | null
  to: number | null
  total: number | null
  next_page: number | null
  prev_page: number | null
}

export const PageBtns = () => {
  const dispatch = useAppDispatch()
  const history = useHistory()
  const routeParams: {
    page: string
  } = useParams()

  const [pageState, setPageState] = useState<pageStateType>({
    current_page: null,
    from: null,
    to: null,
    total: null,
    prev_page: null,
    next_page: null,
  })

  //@ts-ignore
  const pageNumber = +routeParams?.page
  // let currPage = ''

  // switch (history.location.pathname) {
  // }
  const { pathname } = history.location

  const currPage = pathname.includes(routeNames['/companies'].route)

  function handleNextPage() {
    let nextPage = pageNumber + 1 || 1
    history.push({ pathname: `page=${nextPage}` })
  }

  function handlePreviousPage() {
    let prevPage = pageNumber - 1 || 1
    history.push({ pathname: `page=${prevPage}` })
  }

  useEffect(() => {
    loadData()
    async function loadData() {
      const res: any = pathname.includes(routeNames['/companies'].route)
        ? await CompanyService().loadCompanyList(routeParams?.page)
        : pathname.includes(routeNames['/departments'].route)
        ? await DepartmentService().loadDepartmentList(routeParams?.page)
        : pathname.includes(routeNames['/licenses'].route)
        ? await LicenseService().loadLicenseList(routeParams?.page)
        : null
      setPageState({
        to: res?.to,
        total: res?.total,
        current_page: res?.current_page,
        from: res?.from,
        next_page: res?.next_page,
        prev_page: res?.prev_page,
      })
      //@ts-ignore
      pathname.includes(routeNames['/companies'].route)
        ? dispatch(setCompanyList(res?.data))
        : pathname.includes(routeNames['/departments'].route)
        ? dispatch(setDepartmentList(res?.data))
        : dispatch(setLicenseList(res?.data))
    }
  }, [pageNumber])
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      <p className="body-text-3_j">
        {pageState.from}-{pageState.to} з {pageState.total}
      </p>
      <button
        className={styles['arrowWrapper-left']}
        onClick={handlePreviousPage}
        disabled={!pageState.prev_page}
      >
        <img alt="arrow" src={Arrow} />
      </button>
      <button
        className={styles['arrowWrapper']}
        onClick={handleNextPage}
        disabled={!pageState.next_page}
      >
        <img alt="arrow" src={Arrow} />
      </button>
    </div>
  )
}
